import { render, staticRenderFns } from "./TopsFull.vue?vue&type=template&id=8b69009a&scoped=true&"
import script from "./TopsFull.vue?vue&type=script&lang=js&"
export * from "./TopsFull.vue?vue&type=script&lang=js&"
import style0 from "./TopsFull.vue?vue&type=style&index=0&id=8b69009a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b69009a",
  null
  
)

export default component.exports